import React from 'react';

type Translated<T> = T | { en_US?: T };

type LinkItem = {
    label?: Translated<string>;
    url?: Translated<string>;
    newTab?: boolean;
};

type FooterData = {
    col1Links?: LinkItem[];
    col2Links?: LinkItem[];
    col4Links?: LinkItem[];
    companyInfo?: Translated<string>;
    copyright?: Translated<string>;
};

type Props = {
    data: FooterData;
};

const getValue = (value?: Translated<string>) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.en_US ?? '';
};

const Footer: React.FC<Props> = ({ data }) => {

    const col1 = data.col1Links ?? [];
    const col2 = data.col2Links ?? [];
    const col4 = data.col4Links ?? [];
    const companyInfo = getValue(data.companyInfo);
    const copyright = getValue(data.copyright);

    const renderLinks = (links: LinkItem[]) => (
        <ul className="space-y-3">
            {links.map((item, index) => {
                const label = getValue(item.label);
                const url = getValue(item.url);

                if (!label) return null;

                return (
                    <li key={index}>
                        {url ? (
                            <a
                                href={url}
                                target={item.newTab ? '_blank' : '_self'}
                                rel={item.newTab ? 'noopener noreferrer' : undefined}
                                className="text-sm text-white/80 hover:text-white hover:underline"
                            >
                                {label}
                            </a>
                        ) : (
                            <span className="text-sm text-white/80">
                                {label}
                            </span>
                        )}
                    </li>
                );
            })}
        </ul>
    );

    return (
        <footer
            style={{ backgroundColor: "#000" }}
            className="relative mt-0 left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen bg-black text-white"
        >
            {/* MAIN FOOTER */}
            <div className="px-6 sm:px-8 py-10">
                <div className="mx-auto max-w-7xl grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-10">

                    {/* Column 1 */}
                    <div className="md:col-span-3">
                        {renderLinks(col1)}
                    </div>

                    {/* Column 2 */}
                    <div className="md:col-span-2">
                        {renderLinks(col2)}
                    </div>

                    {/* Company Info */}
                    <div
                        className="md:col-span-5 text-sm text-white/80 leading-6 footer-company-info"
                        dangerouslySetInnerHTML={{ __html: companyInfo }}
                    />

                    {/* Column 4 */}
                    <div className="md:col-span-2">
                        {renderLinks(col4)}
                    </div>

                </div>
            </div>

            {/* COPYRIGHT */}
            {copyright && (
                <div
                    style={{ backgroundColor: "#4e4b4b" }}
                    className="border-t border-white/10 py-4 text-center text-xs text-white/60"
                >
                    {copyright}
                </div>
            )}
        </footer>
    );
};

export default Footer;
